import {
    Autocomplete,
    Box,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextField
} from '@mui/material'
import { useEffect, useState } from 'react'
import { useSupplierStore } from '../../../hooks/useSupplierStore'
import { usePriceListCustomerStore } from '../../../hooks/usePriceListCustomerStore'

interface Props {
    open: boolean
    priceList: any
    onClose: () => void
    onList: () => Promise<any>
}

export const ModalAddCustomer: React.FC<Props> = ({
    open,
    priceList,
    onClose,
    onList
}) => {
    const { supppliers, getSuppliers } = useSupplierStore()
    const { createPriceListCustomer } = usePriceListCustomerStore()
    const [selectedSupplier, setSelectedSupplier] = useState<any>(null)
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        getSuppliers()
    }, [])

    const handleAdd = async (): Promise<void> => {
        if (!selectedSupplier) return

        setLoading(true)

        const resp = await createPriceListCustomer({
            idpricelist: priceList?.id,
            idcustomer: selectedSupplier?.id
        })

        if (resp === true) {
            onList()
            onClose()
        }

        setLoading(false)

    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Agregar cliente a la lista</DialogTitle>
            <DialogContent>
                <Box mt={2}>
                    <Autocomplete
                        value={selectedSupplier || null}
                        options={supppliers || []}
                        getOptionLabel={(opt) =>
                            opt?.name_rz && opt?.rut ? `${opt.name_rz} - ${opt.rut}` : ''
                        }
                        isOptionEqualToValue={(opt, val) => opt.name_rz === val?.name_rz}
                        onChange={(e, newVal) => setSelectedSupplier(newVal)}
                        renderInput={(params) => (
                            <TextField {...params} fullWidth size="small" label='Cliente' />
                        )}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}
                    sx={{
                        fontFamily: 'AvenirNextRounded',
                        fontSize: '13px',
                        fontWeight: 600,
                        backgroundColor: '#fff',
                        border: '1px solid #516e80',
                        color: '#516e80',
                        cursor: 'pointer',
                        transition: '0.5s',
                        textTransform: 'none',
                        minWidth: '125px',
                        '&:hover': {
                            backgroundColor: '#fff',
                            border: '1px solid #445f70',
                        },
                    }}
                >
                    Cancelar
                </Button>
                <Button
                    onClick={handleAdd}
                    variant="contained"
                    disabled={!selectedSupplier}
                    sx={{
                        fontFamily: 'AvenirNextRounded',
                        fontSize: '13px',
                        backgroundColor: '#516E80',
                        border: '1px solid #516e80',
                        color: '#FFFFFF',
                        cursor: 'pointer',
                        transition: '0.5s',
                        textTransform: 'none',
                        minWidth: '125px',
                        '&:hover': {
                            backgroundColor: '#445f70',
                            border: '1px solid #445f70',
                        },
                    }}
                >
                    Agregar
                    {loading && <CircularProgress color="inherit" size={12} sx={{ color: '#fff', marginLeft: "10px" }} />}
                </Button>
            </DialogActions>
        </Dialog>
    )
}